module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedMediumItalic.78af0f9.woff";